import {Component, OnInit} from "@angular/core";
import {TeArtefactDto} from "../../../../model/dto/entity/te-artefact.dto";
import {TeArtefactService} from "../../../../service/api/te-artefact.service";
import {TeArtefactVariableService} from "../../../../service/api/te-artefact-variable.service";
import {TinymceAutosave} from "../../../../logic/tinymce-autosave";
import {ActivatedRoute} from "@angular/router";
import {ObjectBaseModeComponent} from "../../../../../../core/shared/object/mvs-object-base/object-base-mode.component";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {MvsMessageService} from "../../../../../../core/shared/service/message/mvs-message.service";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {TeEditorSaveEvent} from "../../te-editor/te-editor.component";
import {TestCaseChangeEvent} from "../../te-test-case/te-test-case.component";
import {TeTemplateGenerateResponseDto} from "../../../../model/dto/entity/te-template-generate-response.dto";
import {DomSanitizer, SafeHtml} from "@angular/platform-browser";
import {ObjectIdentifierWithId} from "../../../../../../core/shared/basic/object-identifier.with.id";
import {TeVariableTypeEnum} from "../../../../enum/te-variable-type.enum";

@Component({
    selector: 'te-artefact-object-base',
    template: '',
    standalone: false
})

export class TeArtefactObjectBaseComponent extends ObjectBaseModeComponent implements OnInit {

    busy: boolean;

    ngOnInit() {
        super.ngOnInit();
        this.initialized = true;
    }

    dto: TeArtefactDto;

    widgetBasicData: WidgetData;
    showBasicData: boolean;
    private autoSave = new TinymceAutosave();

    // Test-related properties
    selectedTestCase: TestCaseChangeEvent;
    templateGenerateResponse: TeTemplateGenerateResponseDto;
    trustedGenerateResponseHtml: SafeHtml;
    trustedGenerateResponsePdf: SafeHtml;
    occurredException: string;
    occurredExceptionDetails: string;
    generatePdf: boolean = false;

    constructor(
        protected crudService: TeArtefactService,
        protected artefactVariableService: TeArtefactVariableService,
        protected coreService: MvsCoreService,
        protected route: ActivatedRoute,
        protected messageService: MvsMessageService,
        public sanitizer: DomSanitizer) {
        super(route);
    }

    /**
     * Save content.
     * @param event
     */
    handleEditorOnSave(event: TeEditorSaveEvent) {

        const dto = new TeArtefactDto();
        dto.id = this.dto.id;
        dto.content = event.content;
        dto.editorTypeEnum = event.editorTypeEnum;

        this.crudService.update(dto).subscribe({
            next: (value) => {
                this.dto.editorTypeEnum = event.editorTypeEnum;
                this.messageService.showSuccessMessageSaved();
                console.log('Updated content data into API');
                let editorContentFromCookie = this.autoSave.getAutoSaveCookie('te.TeArtefactVariable' + this.dto.id);
                if (editorContentFromCookie && dto.content === editorContentFromCookie?.content) {
                    this.autoSave.deleteAutoSaveCookie('te.TeTemplateVariable' + this.dto.id);
                    this.dto = <TeArtefactDto>value; // take over value
                }
            },
            error: (error) => {
                this.messageService.showErrorMessage('Fehler', 'Ein Fehler ist aufgetreten.');
            }
        });

    }

    handleToggleBasicData() {

        // if (this.showBasicData) {
            this.widgetBasicData = WidgetFactory.createWidgetEntityData(
                'te.config.artefact.view',
                'Artefakt',
                this.objectIdentifier.objectType,
                this.objectIdentifier.objectId
            );

        // } else {
        //     this.widgetBasicData = null;
        // }
    }

    handleSelectTestCase(event: TestCaseChangeEvent) {
        this.selectedTestCase = event;
    }

    generateTestCaseFn = (id: number, testCaseId: number, generatePdf: boolean, objectVars: any, simpleVars: any,
                          contextScenarios?: {[alias: string]: string}) =>
        this.crudService.generateViaTestCase(id, testCaseId, generatePdf, objectVars, simpleVars, contextScenarios);

    generateDocument() {

        this.templateGenerateResponse = null;
        this.trustedGenerateResponseHtml = null;
        this.trustedGenerateResponsePdf = null;
        this.occurredException = null;
        this.occurredExceptionDetails = null;

        const objectVariables: { [key: string]: ObjectIdentifierWithId } = {};
        const simpleVariables: { [key: string]: any } = {};

        if (this.selectedTestCase.variables) {
            for (let variable of this.selectedTestCase.variables) {
                if (variable.useCaseVariable) {
                    if (variable.variableType == "object") {
                        objectVariables[variable.alias] = new ObjectIdentifierWithId(variable.useCaseVariable.objectTypeDtoId, null, variable.useCaseVariable.objectId);
                    } else if (variable.variableType == "simple") {
                        simpleVariables[variable.alias] = variable.useCaseVariable.simpleValue;
                    }
                }
            }
        }

        this.busy = true;

        this.crudService.generateViaTestCase(
            this.dto.id,
            this.selectedTestCase.dto.id,
            this.generatePdf,
            objectVariables,
            simpleVariables).subscribe({
            next: (value) => {
                if (value.errors || value.errorOccurred) {
                    this.occurredException = value.exception;
                    this.occurredExceptionDetails = value.exceptionDetails;
                } else {
                    this.templateGenerateResponse = value;
                    if (this.generatePdf) {
                        this.trustedGenerateResponsePdf = this.sanitizer.bypassSecurityTrustResourceUrl(value.document);
                    } else {
                        this.trustedGenerateResponseHtml = this.sanitizer.bypassSecurityTrustHtml(value.document);
                    }
                }
                this.busy = false;
            },
            error: (error) => {
                this.occurredException = 'Fehler bei der Artefakt-Generierung';
                this.occurredExceptionDetails = error?.error?.message || error?.message || 'Unbekannter Fehler';
                this.busy = false;
            }
        });
    }
}